import { Options as IntlMessageFormatOptions } from 'intl-messageformat/src/core';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

const useTrans = (prefix?: string) => {
    const intl = useIntl();

    return useCallback(
        (
            key: string,
            values?: Record<string, any>,
            options?: IntlMessageFormatOptions
        ): string =>
            intl.formatMessage(
                {
                    id: (prefix ?? '') + key,
                    // defaultMessage: `MISSING: ${key}`,
                },
                values,
                options
            ),
        [prefix, intl]
    );
};

export default useTrans;
